import { render, staticRenderFns } from "./DraggableContainer.vue?vue&type=template&id=4ed97d17&scoped=true"
import script from "./DraggableContainer.vue?vue&type=script&lang=ts"
export * from "./DraggableContainer.vue?vue&type=script&lang=ts"
import style0 from "./DraggableContainer.vue?vue&type=style&index=0&id=4ed97d17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed97d17",
  null
  
)

export default component.exports